export default "__VITE_ASSET__Dmn7_4os__"